(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('RelatorioVistaAbertaPromotorService', RelatorioVistaAbertaPromotorService);

  function RelatorioVistaAbertaPromotorService($http, ngsalConfig) {

    var service = {
      retornaRelatorioVistaAbertaPromotor: retornaRelatorioVistaAbertaPromotor
    };

    return service;


    function retornaRelatorioVistaAbertaPromotor(filtroRelatorio) {

      var promise = $http.post("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/relatorio/vistaAberta/promotor",filtroRelatorio).then(function (response) {
          return response.data;
      });

      return promise;
    }



  }

})();
